import { jsx as _jsx } from "react/jsx-runtime";
import { SelectControl } from '@wordpress/components';
import withMetaData from '../../utils/withMetaData';
import { useBackgroundAppContext, usePostBackgroundMessage, } from '../../iframe/useBackgroundApp';
import { ProxyMessages } from '../../iframe/integratedMessages';
const UISidebarSelectControl = (props) => {
    const isBackgroundAppReady = useBackgroundAppContext();
    const monitorSidebarMetaChange = usePostBackgroundMessage();
    return (_jsx(SelectControl, { value: props.metaValue, onChange: content => {
            if (props.setMetaValue) {
                props.setMetaValue(content);
            }
            isBackgroundAppReady &&
                monitorSidebarMetaChange({
                    key: ProxyMessages.TrackSidebarMetaChange,
                    payload: {
                        metaKey: props.metaKey,
                    },
                });
        }, ...props }));
};
export default withMetaData(UISidebarSelectControl);
